<template>
  <div class="container">
    <img class="logo" src="../../assets/imgs/logo.jpg" alt="" />
    <div class="home-body">
      <div class="title">{{ i18n.powerbanktitle }}</div>
      <button class="loginbtn" @click="goOrder">
        <div class="left"></div>
        <div class="center">
          <img class="phoneicon" :src="require('../../assets/imgs/icon_phone_selected.png')" alt="">
          <span v-if="!user">{{ i18n.phone }}</span>
          <span v-else>{{ user && user.pname }}</span>
        </div>
        <div v-if="!user" class="right"></div>
        <img v-else class="right" src="../../assets/imgs/icon_more.png" alt="">
      </button>
      <div class="options" v-if="!user" @click="loginOptionShow = true">{{ $t('login.login') }}</div>
      <div class="options" v-else @click="onLogout">{{ i18n.logout }}</div>
      <div class="normaltitle">{{ i18n.paymentdetail }}</div>
      <div class="paymethod-detail">
        <div class="placeinput">
          <img class="preicon" src="../../assets/imgs/icon_pay.png" alt="">
          <input type="text" readonly :placeholder="`Pre-authorisation ${ currency } ${cabinet && cabinet.yajin || 0}`">
          <img class="afticon" src="../../assets/imgs/icon_detail_green.png" alt="" @click="preAuthorShow = true">
        </div>
      </div>
      <!-- <div class="shopdetail">
        <img src="../../assets/imgs/img_charge_pricing.png" alt="">
        <div class="centermsg">
          <p class="top">{{ currency }} {{ cabinet && cabinet.jifei || 0 }} per {{ cabinet && cabinet.jifeiDanwei || 30 }} minutes</p>
          <p class="bottom">{{ currency }} {{ cabinet && cabinet.fengding || 0 }} per day</p>
        </div>
        <div class="pricing" @click="showRentCostPop">{{ i18n.pricing }} <img src="../../assets/imgs/icon_morearrow.png"></div>
      </div> -->
      <div class="normaltitle">{{ i18n.couponcode }}</div>
      <div class="coupon-code">
        <div class="placeinput">
          <img class="preicon" src="../../assets/imgs/icon_couponcode.png" alt="">
          <input type="text" v-model="couponCode" placeholder="i.e.:FREE60">
        </div>
      </div>
      <div class="rentbtn" @click="onRent">{{ i18n.rent }}</div>
      <div class="agreen">
        {{ i18n.tips }}
        <a @click="viewAgreen('https://parker.chargenow.top/content/privacy_policy.html')">{{ i18n.privacy }}</a>
        {{ i18n.and }}
        <a @click="viewAgreen('https://parker.chargenow.top/content/user_agreement.html')">{{ i18n.term }}</a>
      </div>
    </div>
    <div v-if="loginOptionShow" class="mask" @click="loginOptionShow = false">
      <div class="mask-main" @click.stop>
        <div class="appleline"></div>
        <div class="phonelogin">
          <div class="area" @click="isAreaView = true">
            <span>+{{areaCode}}</span>
            <div class="area-down"></div>
          </div>
          <input type="number" v-model="phone" :placeholder="i18n.phonenumber">
          <img src="../../assets/imgs/icon_next_circle_dark.png" alt="" @click="onSendCode">
        </div>
        <div class="agreen">
          {{ i18n.tips }}
          <a @click="viewAgreen('https://parker.chargenow.top/content/privacy_policy.html')">{{ i18n.privacy }}</a>
          {{ i18n.and }}
          <a @click="viewAgreen('https://parker.chargenow.top/content/user_agreement.html')">{{ i18n.term }}</a>
        </div>
      </div>
    </div>
    <select-area v-model="isAreaView" @select="onSelct"></select-area>
    <PreAuthorTip v-if="preAuthorShow" @close="(res) => preAuthorShow = res"></PreAuthorTip>
    <RentCostTip v-if="rentCostShow" :jifei="cabinet && cabinet.jifei" :jifeiDanwei="cabinet && cabinet.jifeiDanwei || 30" :fengding="cabinet && cabinet.fengding" :yajin="0" :currencyName="currencyName" :currency="currency" @close="(res) => rentCostShow = res"></RentCostTip>
    <!-- <LoginCode v-if="loginCodeShow" @close="(res) => loginCodeShow = res" @submit="onLogin"></LoginCode> -->
  </div>
</template>

<script>
import md5 from 'js-md5'
import { mapState } from 'vuex'
// import { generateUUID } from '../../utils/index'
// import { baseURL } from '../../utils/http'
import { SelectArea } from '../../components/select'
import PreAuthorTip from './component/preauthortip.vue'
import RentCostTip from './component/rentcosttip.vue'
// import LoginCode from './component/logincode.vue'
import { USER_INFO, LOGIN_CODE, SEND_CODE } from '../../apis/user'
import { QR_CODE, ZH_CODE } from '../../apis/cabinet'
import { PAYMODE, CDB_PREAUTH, COUPON_SEND } from '../../apis/payment'
export default {
  components: {
    SelectArea,
    PreAuthorTip,
    RentCostTip
    // LoginCode
  },
  watch: {
    // cabinet (val) {
    //   if (val) {
    //     console.log('设备信息', val)
    //     this.getPayMode()
    //   }
    // }
  },
  computed: {
    ...mapState([
      'browser',
      'user',
      'token',
      'cabinet',
      'system',
      'qrcode',
      'agentId'
    ]),
    scanUrl () {
      if (this.qrcode || this.$route.query.qrcode) {
        return `${QR_CODE}?id=${this.qrcode || this.$route.query.qrcode}`
      }
      if (this.zhcode || this.$route.query.zhcode) {
        return `${ZH_CODE}/${this.zhcode}`
      }
      return ''
    },
    i18n () {
      return this.$t('loginborrow')
    },
    i18nMsg () {
      return this.$t('msg')
    },
    currency () {
      return (this.cabinet && this.cabinet.currency) || (this.user && this.user.pcurrency) || 'UZS'
    },
    currencyName () {
      return (this.cabinet && this.cabinet.currencyName) || (this.user && this.user.pcurrencyName) || '£'
    }
  },
  data () {
    return {
      isAreaView: false,
      areaCode: '44',
      // captchaUrl: '',
      code: '',
      // uuid: '',
      phone: '',
      couponCode: '',
      preAuthorShow: false,
      loginOptionShow: false,
      rentCostShow: false,
      loginCodeShow: false,
      payModeList: [],
      payMode: {
        pPaymentType: 'STRIPE_CARD'
      }
    }
  },
  methods: {
    onSelct (val) {
      this.areaCode = val
    },
    showRentCostPop () {
      this.rentCostShow = true
    },
    viewAgreen (url) {
      window.open(url)
    },
    goOrder () {
      if (this.user) {
        this.$router.push('/order')
      }
    },
    // onCaptcha () {
    //   this.code = ''
    //   this.uuid = generateUUID()
    //   this.captchaUrl = `${baseURL}${USER_CAPTCHA}?uuid=${this.uuid}`
    // },
    onLogout () {
      console.log('退出==')
      this.$confirm({
        title: this.i18nMsg.title,
        content: this.i18nMsg.msg_logout,
        confirmText: this.i18nMsg.confirm,
        cancelText: this.i18nMsg.cancel
      }).then(() => {
        this.$store.commit('user', '')
        this.$store.commit('token', '')
        this.$store.commit('appleIdToken', '')
        // this.$store.commit('qrcode', '')
        this.payModeList = []
      })
    },
    onRent () {
      if (this.couponCode) {
        this.getCouponCode()
        return
      }
      this.onPay()
    },
    onPay () {
      if (this.user) {
        if (this.cabinet && this.cabinet.zujieNum && this.cabinet.zujieNum > 0) {
          this.$toast(this.i18nMsg.exceedorder)
          return
        }
        if (!this.qrcode && !this.$route.query.qrcode) {
          this.$toast(this.i18nMsg.none_code)
          return
        }
        // this.$router.replace(`/result?outTradeNo=${resp.data.outTradeNo}&payMode=stripe`)
        this.$loading(true)
        this.$get(
          `${CDB_PREAUTH}`,
          {
            qrcode: this.qrcode || this.$route.query.qrcode
          },
          resp => {
            this.$loading(false)
            console.log(resp)
            this.$router.push(`/result?outTradeNo=${resp.data.outTradeNo}`)
          },
          error => {
            this.$loading(false)
            this.$toast(error)
          },
          {
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }
        )
      } else {
        this.$toast(this.i18nMsg.unlogin)
      }
    },
    onScan () {
      let url = this.scanUrl
      this.inputCodeShow = false
      this.$loading(true)
      this.$post(
        url,
        {},
        resp => {
          this.$loading(false)
          this.$store.commit('cabinet', {
            qrcode: this.code,
            ...resp
          })
          if (resp.zujieNum && resp.zujieNum > 0) {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: `${this.i18n.msg_rentcount}`.format(resp),
              confirmText: this.i18nMsg.confirm,
              cancelText: this.i18nMsg.cancel
            }).then(() => {
              this.$store.commit('qrcode', '')
            }).catch(() => {
              this.$store.commit('qrcode', '')
            })
          }
        },
        error => {
          this.$loading(false)
          let errstr = ''
          if (error.includes('is offline') || error.includes('离线')) {
            errstr = this.$t('home.offline', { devicecode: this.qrcode })
          } else if (error.includes('Permission') || error.includes('权限')) {
            errstr = this.$t('home.permissionfail')
          } else if (error.includes('not bound') || error.includes('未绑定')) {
            errstr = this.$t('home.unbound', { devicecode: this.qrcode })
          } else if (error.includes('No battery') || error.includes('可用')) {
            errstr = this.$t('home.nobattery', { devicecode: this.qrcode })
          } else {
            errstr = error
          }
          this.$confirm({
            title: this.i18n.msg_fail_title,
            confirmText: this.i18nMsg.confirm,
            content: errstr,
            showCancel: false
          }).then(() => {
            this.$store.commit('qrcode', '')
          })
        }
      )
    },
    loadUser (isOnScan = false) {
      this.$get(
        USER_INFO,
        {},
        resp => {
          if (resp.user) {
            this.$store.commit('user', resp.user)
            this.loginOptionShow = false
            if (isOnScan && this.qrcode) {
              this.onScan()
            }
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_user,
              showOk: false,
              cancelText: this.i18nMsg.cancel
            }).then(() => {
              this.loadUser()
            })
          }
        },
        error => {
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: error,
            showOk: false,
            cancelText: this.i18nMsg.cancel
          }).then(() => {
            this.loadUser()
          })
          console.log(error)
        }
      )
    },
    getCouponCode () {
      this.$loading(true)
      this.$get(
        `${COUPON_SEND}?code=${this.couponCode}`,
        {},
        resp => {
          this.$loading(false)
          console.log(resp)
          this.onPay()
        },
        error => {
          this.$loading(false)
          console.log(error)
          this.onPay()
        }
      )
    },
    getPayMode () {
      this.$loading(true)
      this.$get(
        `${PAYMODE}?id=${this.cabinet.cabinetID}`,
        {},
        resp => {
          this.$loading(false)
          if (resp.data) {
            let list = resp.data
            list.filter((v, i, arr) => {
              if (v.pPaymentType === 'datatrans-web') {
                v.label = 'Credit Card'
                v.phone = 'all'
              }
              return v.pPaymentType === 'datatrans-web'
            })
            this.payModeList = list
            if (list.length > 0) {
              this.payMode = list[0]
              this.loadDataTransScript()
            }
          }
        },
        error => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18n.msg_fail_paymod,
            confirmText: this.i18n.msg_fail_retry,
            cancelText: this.i18n.msg_fail_cancel
          }).then(() => {
            this.getPayMode()
          })
          console.log(error)
        }
      )
    },
    onLogin (code) {
      this.$loading(true)
      this.$post(
        LOGIN_CODE,
        {
          mobile: this.areaCode + this.phone,
          verifyCode: code
        },
        res => {
          console.log(res)
          this.$loading(false)
          if (res.token) {
            this.$store.commit('token', res.token)
            this.onCode()
            this.loginCodeShow = false
            this.loginOptionShow = false
          } else {
            this.$toast(this.i18n.msg_fail_login)
          }
        },
        err => {
          console.log(err)
          this.$loading(false)
        }
      )
    },
    onSendCode () {
      if (!this.phone) {
        this.$toast(this.i18nMsg.msg_fail_phone)
        return
      }
      let timp = new Date().valueOf()
      let str = timp.toString().replace(/0/g, '8')
      let mdsign = md5((str + 'GZzbjkj'))
      // console.log(timp, str, mdsign, this.phone)
      this.$loading(true)
      this.$post(
        SEND_CODE,
        {
          mobile: this.areaCode + this.phone,
          timestamp: timp,
          sign: mdsign,
          useDebug: 'true'
        },
        res => {
          console.log(res)
          this.$loading(false)
          this.onLogin('1234')
        },
        err => {
          console.log(err)
          this.$loading(false)
          this.$toast(err)
        }
      )
    },
    onCode () {
      console.log(this.qrcode)
      if (this.token) {
        this.loadUser()
      }
      if ((this.qrcode || this.$route.query.qrcode) && this.token) {
        this.onScan()
      }
    }
  },
  created () {
    let qrCode = this.qrcode || this.$route.query.qrcode
    console.log('qrCode====', qrCode)
    if (qrCode) {
      this.$store.commit('qrcode', qrCode)
      if (this.user) {
        this.onCode()
      }
    }
  },
  mounted () {
  }
}
</script>

<style lang="less" scoped>
.select{
  color: #000!important;
  background-color: #00FC00!important;
  border: none!important;
}
.selectd{
  border: solid 1px #00FC00!important;
}
.agreen{
  color: #171917;
  text-align: center;
  margin: 40px 0 20px;
  a{
    text-decoration: none;
    font-weight: bold;
  }
}
.loginbtn{
    border: solid 1px #EBEBEB;
    border-radius: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
    width: 100%;
    background: none;
    .phoneicon{
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
    .left{
      width: 10px;
    }
    .center{
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .right{
      display: block;
      width: 50px;
    }
  }
  .container{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 100vh;
  }
  .logo{
    display: block;
    width: 20%;
    margin: 40px auto;
    border-radius: 20px;
  }
.home-body{
  background-color: #fff;
  border-top-left-radius: 100px;
  border-top-right-radius: 100px;
  overflow: hidden;
  padding: 40px;
  box-sizing: border-box;
  height: 100%;
  .title{
    font-family: 'Montserrat-SemiBold';
    text-align: center;
    font-size: 40px;
    font-weight: bold;
    margin: 0 0 50px;
  }
  .options{
    font-family: 'Montserrat-Medium';
    text-align: center;
    color: #C8C8C8;
    margin: 32px 0 60px;
  }
  .normaltitle{
    font-family: 'Montserrat-Medium';
    font-size: 28px;
    color: #171917;
    margin: 30px 0 32px;
  }
  .paymethod{
    display: flex;
    align-items: center;
  }
  .paymethod-item{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    border: solid 1px #EBEBEB;
    border-radius: 20px;
    margin-right: 30px;
    img{
      width: 45px;
      height: 40px;
      margin-right: 10px;
    }
    span{
      color: #000;
      font-size: 28px;
    }
  }
  .placeinput{
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: solid 1px #EBEBEB;
    border-radius: 20px;
    padding: 20px;
    margin: 30px 0 0;
    .preicon{
      width: 38px;
      height: 38px;
      margin-right: 20px;
    }
    .afticon{
      width: 34px;
      height: 34px;
      margin-left: 20px;
    }
    .cvc{
      font-size: 28px;
      color: #C8C8C8;
    }
    input{
      flex: 1;
      border: none;
      outline: none;
    }
  }
  .shopdetail{
    border: dashed 4px #000;
    border-radius: 20px;
    padding: 10px;
    margin: 50px 0 30px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: relative;
    & > img{
      width: 78px;
      height: 142px;
      position: absolute;
      left: 20px;
      top: -30px;
    }
    .centermsg{
      p{
        margin: 10px 0;
      }
      .top{
        font-size: 28px;
        color: #171917;
      }
      .bottom{
        color: #666666;
        font-size: 24px;
      }
    }
    .pricing{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-left: 40px;
      color: #000;
      img{
        width: 40px;
        height: 40px;
        margin-left: 10px;
      }
    }
  }
  .rentbtn{
    width: 100%;
    background: #171917;
    border-radius: 20px;
    color: #fff;
    text-align: center;
    padding: 20px 0;
    font-family: 'Montserrat-SemiBold';
    font-size: 36px;
    font-weight: 500;
    max-height: 108px;
    margin: 40px 0 0;
  }
  .mt-4{
    margin-top: 40px;
  }
}
.facebookbtn{
    border: solid 5px #dadce0;
    color: #3c4043;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    padding: 20px 0;
    margin-bottom: 40px;
    font-size: 28px;
    img{
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
  }
.mask{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(53, 53, 53, 0.5);
  z-index: 100;
  .mask-main{
    position: absolute;
    bottom: 0;
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    border-top-right-radius: 100px;
    border-top-left-radius: 100px;
    padding: 40px;
  }
  .appleline{
    background-color: #EBEBEB;
    width: 30%;
    height: 8px;
    border-radius: 100px;
    margin: 0 auto 40px;
  }
  .loginoptions{
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    margin: 60px 0;
    &-item{
      border: solid 1px #EBEBEB;
      border-radius: 20px;
      color: #666666;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10px 20px;
      margin: 10px 25px 0 0;
      img{
        width: 30px;
        height: 40px;
        margin-right: 10px;
      }
    }
  }
  .phonelogin{
    border: solid 1px #EBEBEB;
    border-radius: 20px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    margin-bottom: 40px;
    img{
      width: 60px;
      height: 60px;
      transform: rotateZ(180deg);
    }
    input{
      flex: 1;
      font-size: medium;
      border: none;
      outline: none;
    }
    .captcha{
      width: 180px;
    }
    .area {
      width: 100px;
      padding: 0 10px;
      display: flex;
      justify-content: space-around;
      align-items: center;
    }
    .area-down {
      // margin-left: 10px;
      width: 0;
      height: 0;
      border-width: 10px 10px 0;
      border-style: solid;
      border-color: black transparent transparent;
    }
  }
  .facebookbtn{
    border: solid 5px #dadce0;
    color: #3c4043;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    padding: 20px 0;
    margin-bottom: 40px;
    font-size: 28px;
    img{
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
  }
  .goolebtn{
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    border: solid 1px #EBEBEB;
    color: #000;
    width: 100%;
    padding: 20px 0;
    margin-bottom: 40px;
    font-size: 28px;
    img{
      width: 60px;
      height: 60px;
      margin-right: 10px;
    }
  }
}
.creditcard-input {
  margin: 48px 48px 48px;
  padding: 20px;
  border-radius: 20px;
  border: 1Px solid #E4E7ED;
}
.creditcard-btn {
  margin: 48px;
}
.addsign{
  float: left;
  background-color: #fff;
  box-shadow: 3px 6px 10px #e8e8e8;
  padding: 10px;
  width: 18%;
  height: 100%;
  border-radius: 20px;
  margin: 33px 0 20px 20px;
  span{
    display: block;
    background-color: #dddddd;
    color: #fff;
    font-size: 85px;
    text-align: center;
    border-radius: 20px;
  }
}
.scroll-x{
  float: right;
  width: 70%;
  overflow-x: scroll;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 20px;
}
.popup-card-list{
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 3px 6px 10px #e8e8e8;
  padding: 10px 20px;
  margin: 20px 20px 20px 0;
  p{
    margin: 0;
  }
  .value{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    color: #00904A;
    font-weight: 500;
    .pBrand{
      font-size: 40px;
      margin-bottom: 10px;
    }
  }
  .deleteicon{
    width: 60px;
    height: 60px;
    position: absolute;
    top: -20px;
    right: -20px;
  }
}
</style>
